export const YOTPO_BASE = 'https://api.yotpo.com';
export const YOTPO_PRODUCTS = `${YOTPO_BASE}/products`;
export const YOTPO_QUESTIONS = `${YOTPO_BASE}/questions`;
export const YOTPO_APPS = `${YOTPO_BASE}/v1/apps`;
export const YOTPO_WIDGET = `${YOTPO_BASE}/v1/widget`;
